/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to true if you want to use the splash screen.
  useCustomCursor: false, // Change this to false if you want the good'ol cursor
};

//Home Page
const greeting = {
  title: "Hello 👋.",
  title2: "Zeyad",
  logo_name: "Zeyad",
  nickname: "Zeyad Tharwat",
  full_name: "Zeyad Tharwat",
  subTitle: "Front-end Developer, Open Source Enthusiast 🔥. Always learning.",
  mail: "mailto:zeyadtharwat21@gmail.com",
};

const socialMediaLinks = {
  /* Your Social Media Link */
  github: "https://github.com/ZeyadTharwat",
  linkedin: "https://www.linkedin.com/in/zeyad-tharwat-90569722b/",
  gmail: "zeyadtharwat21@gmail.com",
};

const skills = {
  data: [
    {
      title: "Front End Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Develop highly interactive Front end / User Interfaces for your web and mobile applications",
        "⚡ Building responsive website front end using ReactJS",
        "⚡ Developing mobile applications using Flutter and Android",
        "⚡ Creating application backend in Node, Express & Flask",
        "⚡ Integration of third party services such as Firebase/ AWS / Digital Ocean",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#FFFFFF",
            color: "#F7DF1E",
          },
        },
        // {
        //   skillName: "PHP",
        //   fontAwesomeClassname: "simple-icons:php",
        //   style: {
        //     color: "#7377AD",
        //   },
        // },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "Next.js",
          fontAwesomeClassname: "simple-icons:nextdotjs",
          style: {
            color: "#000000", // official Next.js black
          },
        },
        
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:nodedotjs",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "NestJS",
          fontAwesomeClassname: "logos:nestjs",
          style: {
            color: "#E0234E",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#439743",
          },
        },
        {
          skillName: "Prisma",
          fontAwesomeClassname: "logos:prisma",
          style: {
            color: "#0C344B",
          }
        },    
        {
          skillName: "Postman",
          fontAwesomeClassname: "simple-icons:postman",
          style: {
            color: "#FF6C37",
          },
        },            
        // {
        //   skillName: "Java",
        //   fontAwesomeClassname: "logos:java",
        //   style: {
        //     color: "#f89820",
        //   },
        // },
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        // {
        //   skillName: "Wordpress",
        //   fontAwesomeClassname: "simple-icons:wordpress",
        //   style: {
        //     color: "#207297",
        //   },
        // },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#E94E32",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "simple-icons:python",
          style: {
            color: "#3776AB",
          },
        },
      ],
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Dr. S. & S. S. Ghandhy College Of Engineering & Technology",
      subtitle: "Diploma in Information Technology",
      logo_path: "ssgandhy.png",
      alt_name: "SETI",
      duration: "2018 - Present",
      descriptions: [
        "⚡ I have studied core subjects like Data Structures, DBMS, Networking, Security, etc.",
        "⚡ I have also completed various online courses for Backend , Web , Mobile App Development, etc.",
        "⚡ I have implemented several projects based on what I've leart under my Computer Engineering course. ",
      ],
      website_link: "http://www.ssgc.cteguj.in/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "M0001: MongoDB Basics",
      subtitle: "MongoDB University",
      logo_path: "mongo.png",
      certificate_link:
        "https://drive.google.com/file/d/12se6bMep48WXA1PlizTBAgCnW0GXM6wq/view?usp=sharing",
      alt_name: "MongoDB University",
      // color_code: "#2AAFED",
      color_code: "#47A048",
    },
    {
      title: "Hackathon",
      subtitle: "Hack The Mountains",
      logo_path: "hackathon1.svg",
      certificate_link:
        "https://drive.google.com/file/d/12u_tkvhgB-K2TIm-RDdJOwYbQ9ccqiqA/view?usp=sharing",
      alt_name: "hackathon",
      color_code: "#E2405F",
    },
    {
      title: "A300: Atlas Security",
      subtitle: "MongoDB University",
      logo_path: "mongo.png",
      certificate_link:
        "https://drive.google.com/file/d/12u_tkvhgB-K2TIm-RDdJOwYbQ9ccqiqA/view?usp=sharing",
      alt_name: "MongoDB University",
      // color_code: "#F6B808",
      color_code: "#47A048",
    },
    {
      title: "Cyber Security & Cyber Forensics",
      subtitle: "Workshop at IIT Bombay",
      logo_path: "iit.png",
      certificate_link:
        "https://drive.google.com/file/d/12uAdjQC5LfrB1ODdxqIY181ugyyQhl-I/view?usp=sharing",
      alt_name: "Workshop",
      color_code: "#2AAFED",
    },
    {
      title: "MLH Local Hack Day: Build",
      subtitle: "Major League Hacking",
      logo_path: "mlh-logo.svg",
      certificate_link:
        "https://drive.google.com/file/d/1ws7g2Oepu76vDFir6SvR_emFAMSkB2ZQ/view?usp=sharing",
      alt_name: "Google",
      color_code: "#fe0037",
    },
    {
      title: "Hack20",
      subtitle: "Flutter Internation Hackathon",
      logo_path: "flutter.png",
      certificate_link:
        "https://drive.google.com/file/d/1JTd8pVlHbP0RVQYtfa4OZgJYGfdiCwM6/view?usp=sharing",
      alt_name: "Flutter Internation Hackathon",
      color_code: "#2AAFED",
    },
    {
      title: "Postman Student Expert",
      subtitle: "Postman",
      logo_path: "postman.png",
      certificate_link:
        "https://badgr.com/public/assertions/h2qevHs4SlyoHErJQ0mn2g",
      alt_name: "Postman",
      // color_code: "#f36c3d",
      color_code: "#fffbf3",
    },
    // color_code: "#8C151599",
    // color_code: "#7A7A7A",
    // color_code: "#0C9D5899",
    // color_code: "#C5E2EE",
    // color_code: "#ffc475",
    // color_code: "#g",
    // color_code: "#ffbfae",
    // color_code: "#fffbf3",
    // color_code: "#b190b0",
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Volunteership",
  description:
    "I've completed one internship. I've mostly done projects on my own and I am actively looking for internships. I love organizing workshops to share my knowledge with others.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work Experience",
      experiences: [
        {
          title: "Full Stack Developer (Intern)",
          company: "Valora Infotech",
          company_url: "https://valora-infotech.business.site/",
          logo_path: "valora.jpg",
          duration: "Oct 2020 - Mar 2021",
          location: "Office",
          description:
            "I worked on the Dashboard project which helps users track their activities while using Walo Application. I also worked on Ocean Inventory Application and it's Admin panel Backend as well as on Ocean Inventory Admin Front-end using React and also worked on Walo Admin Backend.",
          color: "#0071C5",
        },
        {
          title: "Full Stack Developer (Freelancer)",
          company: "NightOwls",
          company_url: "http://nightowls.company/",
          logo_path: "nightowls.jpg",
          duration: "Sep 2020 - Oct 2020",
          location: "Work From Home",
          description:
            "Created Front end of Yearn Financial Mutual Funds website. also degined simple web application for better user experience, designed DB Schemas as well.",
          color: "#ee3c26",
        },
      ],
    },
    {
      title: "Volunteerships",
      experiences: [
        {
          title: "Cross Winter of Code Mentor",
          company: "CWOC",
          company_url: "https://crosswoc.ieeedtu.in/",
          logo_path: "cwoc.png",
          duration: "Feb 2021 - Present",
          location: "Work From Home",
          description:
            "Mentorship responsibilities were to help students plan the project, review issues and pull requests, ensure smooth progress and help them out when they are stuck.",
          color: "#4285F4",
        },
        {
          title: "Campus Hustler",
          company: "Skillenza",
          company_url: "https://skillenza.com/",
          logo_path: "skillenza.png",
          duration: "Feb 2021 - Present",
          location: "Work from Home",
          description:
            "Spread Awareness of new Technologies and new Opportunities to Students and Grow Skillenza Community.",
          color: "#196acf",
        },
        {
          title: "GitHub Student Developer",
          company: "GitHub",
          company_url: "https://github.com/",
          logo_path: "github.png",
          duration: "Nov 2019 - Present",
          location: "Work from Home",
          description:
            "Contribute to Open Source Community and Open Source Project.",
          color: "#040f26",
        },
        {
          title: "Google Local Guide",
          company: "Google Map",
          company_url: "https://maps.google.com/localguides/",
          logo_path: "localguide.png",
          duration: "Sep 2018 - Present",
          location: "Work From Home",
          description:
            "Day-to-day responsibilities of helping local businesses to spread their business to the world. Helping users by writing reviews about different locations and spaces such as shops, malls, etc.",
          color: "#D83B01",
        },
        {
          title: "GDG Student Volunteer",
          company: "Google Developer Groups",
          company_url: "https://gdg.community.dev/",
          logo_path: "gdg.png",
          duration: "Feb 2021 - Present",
          location: "Work From Home",
          description:
            "Google Developer Group Surat Student Volunteer and Member.",
          color: "#D83B01",
        },
        {
          title: "E. F. I. Student Volunteer",
          company: "ENVIRONMENTALIST FOUNDATION OF INDIA",
          company_url: "https://indiaenvironment.org/",
          logo_path: "efi.png",
          duration: "Apr 2017 - Present",
          location: "Work From Home",
          description:
            "Take time out over weekends to join a gang of nation builders, nature enthusiasts to conserve what is left.",
          color: "#5a900f",
        },
      ],
    },
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I always try to use the latest technologies in my projects, My websites always get the best scores in performance, accessibility and seo, I'm comfortable converting desgins to fully responsive and pixel perfect websites with high page speed performance",
  avatar_image_path: "projects_image.svg",
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contact.jpg",
    description:
      "You can contact me at the places mentioned below. I will try to get back to you as fast as I can. ",
  },
  blogSection: {
    title: "Blogs",
    subtitle:
      "I don't blog frequently but when I do something awesome, I do try to document it so it can be helpful to others. I write on Twitter.",
    link: "https://twitter.com/Harikrushn9",
    avatar_image_path: "blogs_image.svg",
  },
};

const projects = {
  data: [
    {
      id: "0",
      image: "landing-page.webp",
      name: "Fully responsive SaaS Landing Page",
      url: "https://landing-page-eight-hazel.vercel.app/",
      description:
        "This landing page is fully animated, fully responsive with 99% performance score, converted from PSD.",
      languages: [
        {
          name: "HTML5",
          iconifyClass: "logos:html-5",
        },
        {
          name: "CSS3",
          iconifyClass: "logos:css-3",
        },
        {
          name: "Bootstrap",
          iconifyClass: "logos:bootstrap",
        },
      ],
    },
    {
      id: "2",
      image: "darkmon.png",
      name: "Darkmon",
      url: "https://darkmon.com/",
      description:
        "Advanced Threat Intelligence Platform is the next-generation solution to measure any organization's exposure risk on the DDC (Dark, Deep & clear) web.",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos:react",
        },
      ],
    },
    
    {
      id: "4",
      image: "sateur.png",
      name: "Satéur",
      url: "https://sateur.com/",
      description:
        "Affordable luxury for all. Discover stunning engagement rings and jewelry with lab-grown diamonds, moissanite, and Satéur Gems®. Serving 100k+ clients globally.",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos:react",
        },
      ],
    },
    {
      id: "3",
      image: "rasmal.png",
      name: "RasMal",
      url: "https://www.rasmal.io/",
      description:
        "RasMal is the-all-in-one platform to automate equity management, facilitate fundraising and enhance governance for every company!",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos:react",
        },
      ],
    },
    {
      id: "1",
      image: "cars-project.webp",
      name: "Car Dealership website",
      url: "https://cars-project.vercel.app/",
      description:
        "A complete real life project for a car selling company made with react, converted from AdobeXD",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos:react",
        },
      ],
    },
    {
      id: "6",
      image: "usedpanda.png",
      name: "UsedPanda",
      url: "https://usedpanda.com/home",
      description:
        "UsedPanda is the UAE largest online marketplace. Buy your laptops, mobile phones, gym equipment, cosmetics, baby care and much more online in Dubai, Abu Dhabi and all UAE",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos:react",
        },
      ],
    },
    {
      id: "5",
      image: "tiffany.png",
      name: "Tiffany",
      url: "https://sateur.com/",
      description:
        "Discover fine jewelry creations of timeless beauty and superlative craftsmanship that will be treasured always.",
      languages: [
        {
          name: "ReactJS",
          iconifyClass: "logos:react",
        },
      ],
    },

    // {
    //   id: "2",
    //   image: "conduit.png",
    //   name: "Social Media App",
    //   url: "https://conduit-nine.vercel.app/",
    //   description:
    //     "Fully functional social media website with authentecation, and great performance score.",
    //   languages: [
    //     {
    //       name: "ReactJS",
    //       iconifyClass: "logos:react",
    //     },
    //   ],
    // },
    // {
    //   id: "3",
    //   image: "carbon.png",
    //   name: "Carbon",
    //   url: "https://carbonn.vercel.app/",
    //   description: "A Fully responsive landing page converted from Figma.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "logos:html-5",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "logos:css-3",
    //     },
    //     {
    //       name: "Bootstrap",
    //       iconifyClass: "logos:bootstrap",
    //     },
    //   ],
    // },
    // {
    //   id: "3",
    //   image: "yeet.png",
    //   name: "Yeet Rocket",
    //   url: "https://yeet-eight.vercel.app/",
    //   description:
    //     "A Fully responsive and animated landing page converted from Figma.",
    //   languages: [
    //     {
    //       name: "HTML5",
    //       iconifyClass: "logos:html-5",
    //     },
    //     {
    //       name: "CSS3",
    //       iconifyClass: "logos:css-3",
    //     },
    //     {
    //       name: "Bootstrap",
    //       iconifyClass: "logos:bootstrap",
    //     },
    //   ],
    // },
  ],
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  degrees,
  certifications,
  experience,
  projectsHeader,
  contactPageData,
  projects,
};
